import { validate as validateUUID } from "uuid";

export type EventDestinationRouteType = "warehouse" | "forwarding";

const BIGINT_ID_PATTERN = /^\d+$/;

export function getEventDestinationRouteType(
  id: string | undefined,
): EventDestinationRouteType | undefined {
  if (!id) {
    return undefined;
  }

  // Event warehouse destinations use UUIDs, while forwarding destinations use bigint ids.
  // Keep the route-shape assumption in one place so it's easier to update if the models change.
  if (validateUUID(id)) {
    return "warehouse";
  }

  if (BIGINT_ID_PATTERN.test(id)) {
    return "forwarding";
  }

  return undefined;
}
